import React from "react";
import PropTypes from "prop-types";
import { DateTime } from "luxon";
import route from "@/shared/ziggy/route";

const Cassette = (props) => {
  const fairDate = DateTime.fromISO(props.fair.date);
  const dayOfWeek = fairDate.setLocale("en").toFormat("ccc");

  // 日付と曜日のカラーを指定
  let dayColor = "";
  if (dayOfWeek === "Sun" || props.fair.isHoliday) {
    // 日曜 または 祝日
    dayColor = "#e5004f";
  } else if (dayOfWeek === "Sat") {
    dayColor = "#007cb7";
  }

  return (
    <a
      className="fairparts__item background-color--contents_bg"
      href={`${route("user.fair.show", {
        fairId: props.fair.id,
      })}?fair_date=${fairDate.toFormat(
        "yyyy-MM-dd",
      )}&utm_source=embedded_fair&utm_medium=referral&utm_content=${
        props.hallId
      }`}
      target="_blank"
      rel="noreferrer"
    >
      <figure className="fairparts__img font-family--text">
        {props.isRecommend && (
          <div className="emphasis-ribbon background-color--label color--label_text">
            おすすめ
          </div>
        )}
        <img
          alt="フェアのイメージ画像"
          src={props.fair.image}
          width="220"
          height="220"
        />
      </figure>
      <div className="fairparts-date font-family--date">
        <p className="fairparts-date__month">{fairDate.toFormat("M")}</p>
        <div className="fairparts-date__day-group">
          <p className="fairparts-date__day" style={{ color: dayColor }}>
            {fairDate.toFormat("d")}
          </p>
          <p className="fairparts-date__weekday" style={{ color: dayColor }}>
            {dayOfWeek}.
          </p>
        </div>
      </div>
      <p className="fairparts__text font-family--text">{props.fair.name}</p>
    </a>
  );
};

/**
 * hallId: 会場ID
 * fair: フェア
 * isRecommend: おすすめフェアかどうか
 */
Cassette.propTypes = {
  hallId: PropTypes.number,
  fair: PropTypes.object.isRequired,
  isRecommend: PropTypes.bool.isRequired,
};

Cassette.defaultProps = {
  hallId: 0,
};

export default Cassette;
